import { render, staticRenderFns } from "./PodImages.vue?vue&type=template&id=4e5e0379&scoped=true&"
import script from "./PodImages.vue?vue&type=script&lang=js&"
export * from "./PodImages.vue?vue&type=script&lang=js&"
import style0 from "./PodImages.vue?vue&type=style&index=0&id=4e5e0379&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e0379",
  null
  
)

export default component.exports